package com.wintermar.inspection.feature.presentation.inspection.landing

actual suspend fun retryPendingSubmitPlatform(onRetry: suspend () -> Unit) {
    // no-op on web
}

actual suspend fun syncInspection(onSync: suspend () -> Unit) {
    // no-op on web
}
